import React from 'react';

type Props = { stroke?: string };

function ImageIcon({ stroke = 'black' }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
    >
      <path
        d='M3.20407 14.5459L8.15147 9.59853C8.44849 9.30151 8.59699 9.15301 8.76824 9.09737C8.91887 9.04842 9.08113 9.04842 9.23176 9.09737C9.40301 9.15301 9.55152 9.30152 9.84853 9.59853L14.7629 14.5129M10.5 10.25L12.6515 8.09853C12.9485 7.80152 13.097 7.65301 13.2682 7.59737C13.4189 7.54842 13.5811 7.54842 13.7318 7.59737C13.903 7.65301 14.0515 7.80152 14.3485 8.09853L16.5 10.25M7.5 5.75C7.5 6.57843 6.82843 7.25 6 7.25C5.17157 7.25 4.5 6.57843 4.5 5.75C4.5 4.92157 5.17157 4.25 6 4.25C6.82843 4.25 7.5 4.92157 7.5 5.75ZM5.1 14.75H12.9C14.1601 14.75 14.7902 14.75 15.2715 14.5048C15.6948 14.289 16.039 13.9448 16.2548 13.5215C16.5 13.0402 16.5 12.4101 16.5 11.15V4.85C16.5 3.58988 16.5 2.95982 16.2548 2.47852C16.039 2.05516 15.6948 1.71095 15.2715 1.49524C14.7902 1.25 14.1601 1.25 12.9 1.25H5.1C3.83988 1.25 3.20982 1.25 2.72852 1.49524C2.30516 1.71095 1.96095 2.05516 1.74524 2.47852C1.5 2.95982 1.5 3.58988 1.5 4.85V11.15C1.5 12.4101 1.5 13.0402 1.74524 13.5215C1.96095 13.9448 2.30516 14.289 2.72852 14.5048C3.20982 14.75 3.83988 14.75 5.1 14.75Z'
        stroke={stroke}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default ImageIcon;
